/**
 * thousands.pipe.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Pipe, PipeTransform } from "@angular/core";

@Pipe({name: "thou"})
export class ThousandsPipe implements PipeTransform {

  public transform (value : number) : string
  {
    if (typeof value === "number")
    {
      return value.toLocaleString();
    }
    else
    {
      return value;
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/support/pipes/thousands.pipe.ts